<template>
  <div class="content">
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="platform">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i>平台管理
        </span>
        <div class="w_normalNav">
          <button class="BlueSmBtn" @click="subSeefrom">搜索</button>
          <button class="OrangeSmBtn" @click="reset">重置</button>
          <button class="GreenSmBtn" @click="toAddNew">新增</button>
        </div>
        <div class="searchForm1">
          <searchForm :items="items" :formPlus="form_jsgl" ref="searchForm_jsgl">
            <template slot="last">
              <el-form-item label="名称">
                <el-input placeholder="请输入名称" v-model="seefrom.name"></el-input>
              </el-form-item>
              <el-form-item label="平台类型">
                <el-select
                  placeholder="请选择平台类型"
                  v-model="seefrom.type"
                  :popper-append-to-body="false"
                >
                  <el-option
                    v-for="item in platformType"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </template>
          </searchForm>
        </div>
        <div class="tableWrapper" v-loading="!showTable">
          <!-- 后端分页 -->
          <easyTable
            apiUrl="operation/video/query"
            :parent="self"
            :config="config"
            :other="other"
            ref="Platform"
          >
            <!-- <template slot="last">
              <el-table-column label="操作" width="250" align="center">
                <template slot-scope="scope">
                  <el-link
                    icon="iconfont iconedit"
                    type="text"
                    size="small"
                    @click="toEdit(scope.$index, scope.row, true)"
                  >编辑</el-link>
                  <el-link
                    icon="iconfont icondelete"
                    type="text"
                    size="small"
                    @click="deleteEquipment(scope.$index, scope.row)"
                  >删除</el-link>
                </template>
              </el-table-column>
            </template>-->
          </easyTable>
        </div>
        <el-dialog class="editDialog" title="新增平台" :visible.sync="editDialogForm">
          <el-form :model="addEquipment" ref="addEquipment">

            <el-form-item label="名称" prop="name">
              <el-input placeholder="请输入名称" v-model="addEquipment.name"></el-input>
            </el-form-item>
            <el-form-item label="厂家" prop="factory">
              <el-input placeholder="请输入厂家" v-model="addEquipment.factory"></el-input>
            </el-form-item>
            <el-form-item label="平台类型" prop="type">
              <el-select placeholder="请选择平台类型" v-model="addEquipment.type">
                <el-option
                  v-for="item in platformType"
                  :key="item.value"
                  :value="item.value"
                  :label="item.name"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="平台IP" prop="platformIP">
              <el-input placeholder="请输入平台IP" v-model="addEquipment.platformIP"></el-input>
            </el-form-item>
            <el-form-item label="平台端口" prop="platformPort">
              <el-input placeholder="请输入平台端口" v-model="addEquipment.platformPort"></el-input>
            </el-form-item>
            <el-form-item label="账号" prop="account">
              <el-input placeholder="请输入账号" v-model="addEquipment.account"></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="password">
              <el-input placeholder="请输入密码" v-model="addEquipment.password"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button class="cancelButton" @click="editDialogForm = false">取消</el-button>
            <el-button class="confirmButton" @click="Confirm">确定</el-button>
          </div>
        </el-dialog>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tabName: "platform",
      form_jsgl: {},
      showTable: true,
      items: [],
      other: {},
      seefrom: {
        name: "",
        type: ""
      },
      addEquipment: {
        name: "",
        factory: "",
        type: "",
        platformIP: "",
        platformPort: "",
        account: "",
        password: ""
      },
      platformType: [],
      editDialogForm: false,
      status: "",
    };
  },
  computed: {
    self() {
      return this;
    },
    config() {
      return [
        {
          prop: "name",
          label: "名称"
        },
        {
          prop: "factory",
          label: "厂家"
        },
        {
          prop: "typeName",
          label: "平台类型"
        },
        {
          prop: "platformIP",
          label: "平台IP"
        },
        {
          prop: "platformPort",
          label: "平台端口"
        },
        {
          prop: "account",
          label: "账号"
        },
        {
          prop: "password",
          label: "密码"
        }
      ];
    }
  },
  components: {
    normalNav: () => import("public/normalNav"),
    searchForm: () => import("public/searchForm"),
    easyTable: () => import("public/easyTable")
  },
  methods: {
    //搜索
    subSeefrom() {
      this.other = this.seefrom;
      this.$nextTick(this.$refs.Platform.getData);
    },
    //重置
    reset() {
      this.seefrom = {};
    },
    //新增
    toAddNew() {
      this.editDialogForm = true;
      this.status = 1;
      this.addEquipment = {
        name: "",
        factory: "",
        type: "",
        platformIP: "",
        platformPort: "",
        account: "",
        password: ""
      };
      if (this.$refs["addEquipment"])
        this.$refs["addEquipment"].clearValidate();
    },
    //修改
    // toEdit(index, row) {
    //   this.status = 2;
    // },
    //确认
    Confirm() {
        this.$axiospost("operation/video/add", {
          name: this.addEquipment.name,
          factory: this.addEquipment.factory,
          type: this.addEquipment.type,
          platformIP: this.addEquipment.platformIP,
          platformPort: this.addEquipment.platformPort,
          account: this.addEquipment.account,
          password: this.addEquipment.password
        }).then (res => {
          this.subSeefrom();
          this.editDialogForm = false;
        })
    },
    //删除
    // deleteEquipment(index, row) {
    //   this.$confirm("是否删除该网关？", "删除操作", {
    //     confirmButton: "确定",
    //     cancelButton: "取消",
    //     type: "warning"
    //   }).then(() => {
    //     this.$axiosdelete("operation/camera/delete", {
    //       params: {
    //         id: row.id
    //       }
    //     }).then(res => {
    //       this.$message.success("删除成功！")
    //       this.subSeefrom();
    //     });
    //   });
    // }
  },
  created() {
    //初始化平台类型
    this.$axiosget("operation/dictionaryData/queryByKey", {
      params: {
        key: "videoPlatform"
      }
    }).then(res => {
      this.platformType = res.data.data
      this.platformType.push
    })
  }
};
</script>

<style lang="less">
.w_normalNav {
    padding-top: 10px;
    height: 52px;
    position: absolute;
    top: -52px;
    right: 32px;
    z-index: 99;
  }
.el-input__inner:focus {
  border: 1px solid #3587c7;
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute2/systemConfiguration/first/vedio/platform.vue